/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/VideoTranscript/theme';

export const VideoTranscriptTheme = theme;
